import { useEffect } from 'react';
import { ErrorShell } from './ErrorShell';

/** 404 — 경로 매칭 실패 시 catch-all 라우트에서 사용 */
export function NotFoundPage() {
  useEffect(() => {
    document.title = '페이지를 찾을 수 없어요 · 시세공간';
  }, []);
  return (
    <ErrorShell
      code="404"
      title="페이지를 찾을 수 없어요"
      description="요청하신 페이지가 존재하지 않거나, 주소가 변경되었어요."
      hint="주소를 다시 확인해주세요."
    />
  );
}
